<template>
  <div class="layout mysql-sildeMenu-page">
    <Menu :active-name="$route.name" theme="light" width="auto" :open-names="['1']" @on-select="turnToPage"
          mode="horizontal">
      <MenuItem v-for="item in mysqlMenu" :name="item.name" :key="item.name">{{item.title}}</MenuItem>
      <span style="float: right; padding: 0 10px; color: #999; font-size: 12px">MySQL 数据库</span>
    </Menu>
    <Layout :style="{padding: '3px 0 0 0'}">
      <Content :style="{padding: '8px', minHeight: '280px', background: '#fff', zIndex: '0'}">
        <Layout>
          <Content :style="{padding: '0', minHeight: '280px', background: '#fff'}">
            <keep-alive>
              <router-view/>
            </keep-alive>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      params: '',
      query: '',
      mysqlMenu: [
        {
          name: 'mysqlInstanceInfo',
          title: '基本信息'
        },
        {
          name: 'mysqlInstanceDatabase',
          title: '数据库管理'
        },
        {
          name: 'mysqlInstanceUser',
          title: '账户管理'
        },
        {
          name: 'mysqlInstanceSQL',
          title: 'SQL控制台'
        },
        {
          name: 'mysqlInstanceParam',
          title: '参数设置'
        },
        {
          name: 'mysqlParamList',
          title: '参数管理'
        },
        {
          name: 'mysqlInstanceBackup',
          title: '备份恢复'
        },
        {
          name: 'mysqlInstanceLog',
          title: '慢查日志'
        },
        {
          name: 'mysqlInstanceOpsLog',
          title: '操作日志'
        }
      ]
    }
  },
  methods: {
    turnToPage (name) {
      this.$router.push({
        name: name,
        params: this.$route.params,
        query: this.$route.query
      })
    }
  }
}
</script>
<style lang="less">
  @media screen and (max-width: 640px) {
    .mysql-sildeMenu-page {
      .ivu-layout-sider {
        max-width: initial !important;
        width: 100% !important;
        margin-bottom: 14px;
      }
      .ivu-menu-light {
        background: #f5f7f9;
        border-bottom: 1px solid #dcdee2;
      }
      .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item {
        padding: 8px 16px;
      }
      .ivu-layout-has-sider {
        display: block;
      }
      .ivu-layout-sider {
        max-width: initial !important;
        width: 100% !important;
      }
      .ivu-menu-horizontal {
        height: 42px;
        line-height: 42px
      }
      .ivu-menu-item-group-title {
        display: none;
      }
      .ivu-menu-vertical .ivu-menu-item-group-title {
        height: 34px;
        line-height: 34px;
        font-size: 12px;
        padding-left: 13px;
        display: none;
      }
      .ivu-menu-item-group > ul {
        overflow-x: auto;
        & > div.menu-div {
          display: flex;
        }
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .ivu-menu-vertical .ivu-menu-item {
        min-width: 88px;
        padding: 10px 11px;
        text-align: center;
      }
      .ivu-menu-vertical .ivu-menu-item:nth-of-type(2) {
        min-width: 102px;
      }
      .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
        background: none;
      }
      .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
        width: 100%;
        height: 2px;
        top: initial;
      }
    }
  }
</style>
